import { render, staticRenderFns } from "./deckItem.vue?vue&type=template&id=89147a74"
import script from "./deckItem.vue?vue&type=script&lang=js"
export * from "./deckItem.vue?vue&type=script&lang=js"
import style0 from "./deckItem.vue?vue&type=style&index=0&id=89147a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports